import { useWSModal } from "@wingspanhq/fe-component-library";
import { WherePayoutModal } from ".";

export const useWherePayoutModal = () =>
  useWSModal(WherePayoutModal, {
    title: "Where is my payout?",
    size: "S"
  });
